export default (type) =>
  [
    'AutoCompleteSearch',
    'BooleanInput',
    'BulkEdit',
    'CatalogActivity',
    'CodeEditor',
    'Date',
    'InlineEditors',
    'Number',
    'Select',
    'Text',
    'TextArea',
  ].includes(type);
